import axios from '@shared/axios-shared';

export const createAccountSession = () =>
	axios.post('/api/v2/billing/stripe/connect/account-session');

export const getConnectStatus = () =>
	axios.get('/api/v2/billing/stripe/connect/status');

// Mints a single-use Express Dashboard login link. The URL is short-lived and
// one-time-use, so call this on click and open the returned URL immediately.
export const getStripeLoginLink = () =>
	axios.post('/api/v2/billing/stripe/connect/login-link');
